import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { currencyFormatter } from '../Modules/JobRanges/Utils/Utils';
import moment from 'moment';

export default class PricingAuditRow extends Component {
  static propTypes = {
    row: PropTypes.object
  };

  render() {
    const { first_name, last_name, meta, event_data, event_time_epoch } = this.props.row;
    let userName = `${first_name} ${last_name}`;
    if (meta.prev_first_name || meta.prev_last_name) {
      userName += '*';
    }

    return (
      <React.Fragment>
        {event_data.changes.map((change, index) => {
          const actionText = this.renderEventText(change);
          if (!actionText) {
            return null;
          }

          return (
            <tr className="table__pricingAudit--tableBodyRow" key={index}>
              <td className="table__pricingAudit--tableData" id="pricingAudit--date">
                {moment.unix(event_time_epoch).format('MMMM Do YYYY, h:mm a')}
              </td>
              <td className="table__pricingAudit--tableData">{userName}</td>
              <td className="table__pricingAudit--tableData">{actionText}</td>
            </tr>
          );
        })}
      </React.Fragment>
    );
  }

  renderEventText(event) {
    switch (event.action) {
      case 'changed':
        return this.renderChangeEvent(event);
      case 'added':
        return this.renderAddedEvent(event);
      case 'refreshed':
        return this.renderRefreshedEvent(event);
      case 'removed':
        return this.renderRemovedEvent(event);
      case 'merged':
        return this.renderMergeEvent(event);
    }

    return null;
  }

  renderChangeEvent(event) {
    let { newValue, prevValue, property } = event; // eslint-disable-line
    let reviewers = '';
    let actionChange = '';

    if (
      ['total revenue', 'employees count', 'Salary Minimum', 'Salary Midpoint', 'Salary Maximum'].includes(property)
    ) {
      prevValue = currencyFormatter(prevValue, { payType: 'annual', roundToNearest: 1 });
      newValue = currencyFormatter(newValue, { payType: 'annual', roundToNearest: 1 });
    }

    if (property === 'manager review status') {
      reviewers = event.reviewers
        .flat()
        .map(r => (r ? `${r.first_name} ${r.last_name}` : null))
        .join(', ');
      if (newValue[0] === 'Incomplete') {
        actionChange = 'New';
      }
    }

    return (
      <React.Fragment>
        {actionChange ? actionChange : 'Changed'}
        <span className="span__tableData span__tableData--bold">{property}</span>
        {event.of ? ` of ${event.of} ` : ''}
        {property === 'manager review status' && event.newValue[0] === 'Incomplete' ? (
          'opened for ' + reviewers
        ) : (
          <span className="span__tableData span__tableData--negative">{prevValue}</span>
        )}
        <span className="span__tableData span__tableData--positive">{newValue}</span>
        {property === 'manager review status' &&
        (event.newValue[0] === 'NeedsWork' || event.newValue[0] === 'LooksGood')
          ? 'by ' + reviewers
          : ''}
      </React.Fragment>
    );
  }

  renderAddedEvent(event) {
    return (
      <React.Fragment>
        Added
        <span className="span__tableData span__tableData--bold">{event.property}</span>
        {event.of ? `${event.of}` : ''}
        {event.addedItems &&
          event.addedItems.map((addedItem, index) => {
            return (
              <span key={index} className="span__tableData span__tableData--positive">
                {addedItem.auditDisplayValue}
              </span>
            );
          })}
      </React.Fragment>
    );
  }

  renderRefreshedEvent(event) {
    return (
      <React.Fragment>
        Refreshed
        <span className="span__tableData span__tableData--bold">{event.property}</span>
        {event.of ? `${event.of}` : ''}
        {event.addedItems &&
          event.addedItems.map((addedItem, index) => {
            return (
              <span key={index} className="span__tableData span__tableData--positive">
                {addedItem.auditDisplayValue}
              </span>
            );
          })}
      </React.Fragment>
    );
  }

  renderRemovedEvent(event) {
    return (
      <React.Fragment>
        Removed
        <span className="span__tableData span__tableData--bold">{event.property}</span>
        {event.of ? `${event.of}` : ''}
        {event.removedItems &&
          event.removedItems.map((removedItem, index) => {
            return (
              <span key={index} className="span__tableData span__tableData--positive">
                {removedItem.auditDisplayValue}
              </span>
            );
          })}
      </React.Fragment>
    );
  }

  renderMergeEvent(event) {
    return (
      <React.Fragment>
        Merged
        <span className="span__tableData span__tableData--bold">{event.property}</span>
        {event.of ? `${event.of}` : ''}
        {event.addedItems &&
          event.addedItems.map((addedItem, index) => {
            return (
              <span key={index} className="span__tableData span__tableData--positive">
                {addedItem.auditDisplayValue}
              </span>
            );
          })}
      </React.Fragment>
    );
  }
}
